import React, {Component} from 'react';
import Loading from '../loading';
import Paginator from '../paginator';
import classnames from 'classnames';
import {isValidURL} from '../../utils/url';
import LocalizedStrings from '../../localization/strings';

export default class DataTable extends Component {
    onItemClick(item) {
        if (this.props.clickable) {
            this.props.clickable(item);
        }
        return false;
    }
    render() {
        const {
            config,
            items,
            loading,
            className,
            responsive = true
        } = this.props;
        if (loading) {
            return (<Loading/>)
        }
        return (
            <div>
                <table className={classnames('table', responsive && 'responsive', className)}>
                    <thead>
                        <tr>
                            {config.cols.map((col, index) => {
                                return <th key={`header-${index}`}>{col.header}</th>
                            })
}
                        </tr>
                    </thead>
                    <tbody>
                        {items.map(item => {
                            return (
                                <tr key={`table-item-${item.id || item.uuid}`} onClick={this.onItemClick.bind(this, item)}>
                                    {config.cols.map((col, index) => {
                                        let valueDisplay = typeof col.value === 'function'
                                            ? col.value(item)
                                            : item[col.value];
                                        if(isValidURL(valueDisplay)){
                                            return (<td key={`table-col-${item.id}-${index}`}>
                                                <a href={valueDisplay}>{LocalizedStrings.tableLink}</a>
                                            </td>)
                                        }
                                        return <td key={`table-col-${item.id}-${index}`}>
                                            {col.header && <div className="responsive-header">{col.header}:</div>}

                                            {valueDisplay}
                                        </td>
                                    })
}
                                </tr>
                            )
                        })
}

                    </tbody>

                </table>

                <Paginator totalPages={this.props.totalPages} currentPage={this.props.page} paginationAction={this.props.loadAction}/>
            </div>

        )
    }
}

// export default function DataTable(props) {
//     const {config, items, loading} = props;
//     if (loading) {
//         return (<Loading/>)
//     }
//     return (
//         <div>
//             <table className="table responsive">
//                 <thead>
//                     <tr>
//                         {config.cols.map((col, index) => {
//                             return <th key={`header-${index}`}>{col.header}</th>
//                         })
// }
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {items.map(item => {
//                         return (
//                             <tr key={`table-item-${item.id || item.uuid}`}>
//                                 {config.cols.map((col, index) => {
//                                     let valueDisplay = typeof col.value === 'function'
//                                         ? col.value(item)
//                                         : item[col.value];
//
//                                     return <td key={`table-col-${item.id}-${index}`}>{valueDisplay}</td>
//                                 })
// }
//                             </tr>
//                         )
//                     })
// }
//
//                 </tbody>
//
//             </table>
//
//             <Paginator totalPages={this.params.total} currentPage={this.props.page}/>
//         </div>
//
//     )
// }



// WEBPACK FOOTER //
// ./src/js/components/data-table/data-table.js